export const AREA_PROPS = {
  areaId: String,
  areaName: String,
  selectFullLevel: {
    type: Boolean,
    default: false
  },
  hotCity: Array, // 热区数据 [{label: string, value: string}]
  showHotCity: {
    type: Boolean,
    default: true
  },
  searchOption: Object,
  confirmInWatch: {
    type: Boolean,
    default: false
  },
  /*
    {
      url: string,
      maxlength: number,
      minlength: number,
      disabled: boolean,
      beforeSelectParams: function, // 选择之前
      formatResult: function, // 格式化数据
      afterSelected: function // 选择之后
      label: string,
    }
  */
  level: { // 默认可支持展示到的层级
    type: [Number, String],
    default: 5
  },
  contentPopoverProps: Object,
  inputLabelDelimiter: {
    type: String,
    default: ''
  },
  afterConfirm: Function, // 选中之后的回调
  disabled: Boolean,
  confirmNextLevel: {
    type: Boolean,
    default: true
  },
  placeholder: String
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/props/index.js